import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import uz from './locales/uz.json';
import ru from './locales/ru.json';
import en from './locales/en.json';
import type { Lang } from '@/types';
import { isPrerenderedPage } from '@/ssr/hydration';

export const SUPPORTED_LANGS: Lang[] = ['uz', 'ru', 'en'];
export const DEFAULT_LANG: Lang = 'uz';
export const LANG_STORAGE_KEY = 'sqluz-lang';

export const resources = {
  uz: { translation: uz },
  ru: { translation: ru },
  en: { translation: en },
} as const;

const isBrowser = typeof window !== 'undefined';

function readStoredLang(): Lang | null {
  try {
    const v = localStorage.getItem(LANG_STORAGE_KEY);
    return v && (SUPPORTED_LANGS as string[]).includes(v) ? (v as Lang) : null;
  } catch {
    return null;
  }
}

/**
 * Foydalanuvchi tanlagan til. Prerender qilingan sahifa DEFAULT_LANG (uz) da
 * hydrate qilinadi (server HTML bilan mos kelishi uchun), keyin shu tilga o'tiladi.
 */
export const PREFERRED_LANG: Lang = (isBrowser && readStoredLang()) || DEFAULT_LANG;

if (isBrowser) i18n.use(LanguageDetector);

i18n.use(initReactI18next).init({
  resources,
  // Server va prerender qilingan sahifaning birinchi (hydration) renderi — doim uz
  lng: !isBrowser || isPrerenderedPage() ? DEFAULT_LANG : undefined,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  load: 'languageOnly',
  initImmediate: false, // resurslar bundle ichida — sinxron init (SSR uchun shart)
  interpolation: {
    escapeValue: false, // React o'zi XSS'dan himoyalaydi
  },
  detection: {
    order: ['localStorage', 'htmlTag', 'navigator'],
    lookupLocalStorage: LANG_STORAGE_KEY,
    caches: ['localStorage'],
  },
  returnObjects: false,
});

// <html lang="..."> ni sinxron ushlab turish
if (isBrowser) {
  i18n.on('languageChanged', (lng) => {
    document.documentElement.setAttribute('lang', lng);
  });
}

export default i18n;
